import { render } from "./CreateAccountModal.vue?vue&type=template&id=04a1c9c0&scoped=true"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js"

import "./CreateAccountModal.vue?vue&type=style&index=0&id=04a1c9c0&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a1c9c0"]])

export default __exports__